var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('top-navbar'),_c('sidebar'),_c('div',{staticClass:"content-wrapper",staticStyle:{"min-height":"36px"}},[_c('router-view')],1),_c('content-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }